import MultiSelect from '../inputs/MultiSelect'
import PaletteDateRange from './PaletteDateRange'
import './PaletteFacets.css'

// Config-driven facet row. Each facet is:
//   { key, label, kind: 'multiselect' | 'daterange', options?, placeholder?,
//     getOptionValue?, getOptionLabel? }
// `values` is keyed by facet key; onChange(key, nextValue) updates one facet.
// Kept generic so any feature can describe its own facets declaratively.
function PaletteFacets({ facets, values, onChange }) {
  if (!facets?.length) return null

  return (
    <div className="palette-facets">
      {facets.map((facet) => (
        <div className="palette-facet" key={facet.key}>
          <span className="palette-facet-label">{facet.label}</span>
          {facet.kind === 'daterange' ? (
            <PaletteDateRange
              value={values[facet.key] || {}}
              onChange={(next) => onChange(facet.key, next)}
            />
          ) : (
            <MultiSelect
              value={values[facet.key] || []}
              onChange={(next) => onChange(facet.key, next)}
              options={facet.options || []}
              placeholder={facet.placeholder || 'Any'}
              getOptionValue={facet.getOptionValue}
              getOptionLabel={facet.getOptionLabel}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default PaletteFacets
